import '../deps/SM';
import auth from '../deps/login/index';
import ProfileGet from '../deps/profile/index';
import ProfileSet from '../deps/profile/set';

const platform = Uplib.native.getPlatform();

const cache = UpSDK.cache;

let defaultCfg = {
    oauthtype: ''
}

const h5login = Object.assign({
	init(complete) {
		// 若是客户端
		if (platform == 'uplive') {
            Uplib.loading.show();
			Uplib.native.getConfigs({
                invalid: 0,
                complete: (res)=>{
                    
                    res.userToken = res.usertoken;
                	UpSDK.writeLoginInfo(res);

					let getProfileCount = 0;
					let _getProfile = (uid) => {
		                let profile = new ProfileGet(res.uid);

						 profile.promise.done((data) => {
                           
			                let countryCode = data.countryCode;

			                let user =  Object.assign({}, res, {
			                    username: data.username,
			                    avatar: data.avatar,
			                    countryCode: data.countryCode,
			                    gender: data.gender,
			                    grade: data.grade,
			                    upliveCode: data.upliveCode
			                });

			                if (!data.countryCode) {
				                this.setProfile(user);
				            } else {
                                Uplib.loading.hide();

                                UpSDK.writeLoginInfo(user);
                                complete(UpSDK.getUserInfo());
                                // UpSDK.emit('getUserSuccess', UpSDK.getUserInfo());
                            }

			            }).fail((data) => {
			                ++getProfileCount;

			                if (getProfileCount > 3) {
			                    Uplib.notification.simple('Fail to get your personal information', 100 * 1000);
			                } else {
			                    
                                setTimeout(()=>{
                                    _getProfile(uid);
                                }, 1000);
			                }
			            })
			        }
                    _getProfile(res.uid);
                },
                errtip: function() {
                    // 不支持协议
                }
            });
		} else {
			this.getSMDeviceId().done(() => {
                cache.removeCache('user');
	            auth.init(defaultCfg);
	        })
		}
    },

    getDefaultCountryCode() {
        let systemLanguage = UpSDK.config.systemLanguage;

        return systemLanguage.split('-')[1].toUpperCase();
    },

    setProfile(userData) {
        let countryCode = this.getDefaultCountryCode();
        if (countryCode == 'US') {
            countryCode = 'GB';
        }
        let setProfileCount = 0;

        let _setProfile = () => {
            let profileset = new ProfileSet({
                countryCode: countryCode
            });

            profileset.promise.then(
                (data) => {
                    userData.countryCode = countryCode;
                    UpSDK.writeLoginInfo(userData);
                    Uplib.loading.hide();
                    UpSDK.emit('getUserSuccess', UpSDK.getUserInfo());
                },
                function() {
                    ++setProfileCount;

                    if (setProfileCount > 3) {
                        Uplib.loading.hide();
                        Uplib.notification.simple('Fail to set your country / region', 100 * 1000);
                    } else {
                        _setProfile(countryCode);
                    }
                }
            );
        }

        _setProfile();
    },

    getSMDeviceId(){
    	let defer = $.Deferred();
	    // 无论是否使用游客，都产生一个smd（数美的deviceId）
	    // 并且存储到本地
	    let cacheDeviceId = cache.getCache('smDeviceId');

	    if (!cacheDeviceId) {

	        // 数美JS已经加载完成
	        if (typeof SMSdk !== 'undefined') {
	            window.smDeviceId = SMSdk.getDeviceId();
	            cache.setCache('smDeviceId', window.smDeviceId);
	            defer.resolve();
	        } else {

	            // 否则监听事件，等待sdk加载完成
	            $.channel.on('smsdkLoaded', () => {
	                window.smDeviceId = SMSdk.getDeviceId();
	                cache.setCache('smDeviceId', smDeviceId);
	                defer.resolve();
	            });

	            $.channel.on('smsdkLoadedError', () => {
	                defer.resolve();
	            })
	        }
	    } else {
	        window.smDeviceId = cacheDeviceId;
	        defer.resolve();
	    }

	    return defer;
    }
}, Uplib.Events)


const _init = function(options) {
    options = options || {};

    defaultCfg = Object.assign(defaultCfg, options);

    h5login.init();
}

const login = function(cfg) {
    _init.apply(h5login, arguments);

    return h5login;
}

let bauthtype = cache.getCache('bizoauthtype');

if (bauthtype) {

	let oauthcode = Uplib.url.query('code') || Uplib.url.query('oauth_token');

	cache.removeCache('bizoauthtype');

	if (oauthcode) {
		login({
			oauthtype: bauthtype
		})
	}
}

UpSDK.login = login;
UpSDK.nativeLogin = (complete=()=>{})=>{
    h5login.init(complete);
};
UpSDK.getSMDeviceId = h5login.getSMDeviceId;



// WEBPACK FOOTER //
// ./src/js/openjs/uph5/login.js